(() => {
  if (document.querySelector('[data-legal-nav-init]')) return;

  const sidebars = document.querySelectorAll('.armada-legal-sidebar');
  const content = document.querySelector('.armada-legal-content .armada-content-block__main .rte');
  if (!sidebars.length || !content) return;

  const headings = content.querySelectorAll('h2');
  if (!headings.length) return;

  content.setAttribute('data-legal-nav-init', '');

  const allLinks = document.querySelectorAll('.armada-legal-sidebar__link');
  const linkMap = new Map();
  allLinks.forEach((link) => linkMap.set(link.getAttribute('href'), link));

  // AAS-5624: how far an anchor target has to clear the top of the viewport to
  // land below the sticky header — the USP bar plus the header row — instead of
  // the hardcoded 80px that counted neither. Same source as smooth-scroll-nav.js;
  // StickyHeader has written the measured px value long before a link is clicked.
  const headerOffset = () => {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 80;
    const scrollSpacing = parseFloat(rootStyles.getPropertyValue('--space-5')) || 0;
    return headerHeight + scrollSpacing;
  };

  // Smooth scroll on click
  allLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      if (!href) return;
      const target = document.getElementById(href.slice(1));
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // Scroll spy
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          allLinks.forEach((l) => l.classList.remove('armada-legal-sidebar__link--active'));
          const active = linkMap.get(`#${entry.target.id}`);
          if (active) active.classList.add('armada-legal-sidebar__link--active');
        }
      });
    },
    { rootMargin: '-10% 0px -60% 0px' }
  );

  headings.forEach((heading) => observer.observe(heading));
})();
